<div
    role="group"
    class="agpr-formField agpr-seriesPickerField"
    [ngClass]="{ 'agpr-seriesPickerField--hidden': !showPicker }"
    [attr.aria-labelledby]="field.headingId"
>
    <agpr-panel
        *ngIf="field.label && showLabel; else picker"
        [header]="field.label | localize"
        [toggleable]="false"
        [contentPadding]="false"
    >
        <ng-template #panelHeader *ngIf="showContent && isNewReport">
            <div class="agpr-panelHeader-selectedCharts">
                {{ 'Reports.quickReport.chart' | localize }}
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-infoIconStyle"
                    [agprTooltip]="selectedCharts | listTooltip"
                    [escape]="false"
                ></span>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="picker"></ng-container>
    </agpr-panel>
    <ng-template #picker>
        <div class="agpr-seriesPickerField-message">
            <agpr-message
                *ngIf="!showContent"
                [severity]="messageSeverityEnum.info"
            >
                {{ 'Reports.quickReport.chart.singleSource.error' | localize }}
            </agpr-message>
        </div>
        <ul
            [id]="id + '.sourceList'"
            [dndDropzone]="['series']"
            dndEffectAllowed="move"
            (dndDrop)="onDropSeries($event)"
        >
            <li
                dndPlaceholderRef
                class="agpr-drag-placeholder"
            ></li>
            <li
                *ngFor="let series of seriesList; let i = index"
                class="agpr-seriesPickerField-series agpr-contextMenu-parent"
                [style.display]="showContent ? 'block' : 'none'"
                [attr.aria-labelledby]="field.multiSeries ? 'seriesPickerField_seriesHeadingLabel_multiSeries_' + i : 'seriesPickerField_seriesHeadingLabel_singleSeries'"
                [dndDraggable]="series"
                [dndDisableIf]="isInputFocused"
                dndType="series"
                dndEffectAllowed="move"
                (dndStart)="onDragStartSeries(series)"
                (dndEnd)="cleanupAfterDragCompleted($event)"
            >
                <div
                    *ngIf="!field.multiSeries && showLabel"
                    class="agpr-seriesPickerField-seriesHeading"
                >
                    <span
                        id="seriesPickerField_seriesHeadingLabel_singleSeries"
                        class="agpr-seriesPickerField-seriesHeadingLabel"
                    >
                        {{ 'Reports.series.source.label' | localize }}
                        <span *ngIf="field.required" class="agpr-seriesPickerField-seriesHeadingLabel-required" aria-hidden="true">*</span>
                        <span *ngIf="field.required" class="sr-only"> {{ 'required' | localize }} </span>
                    </span>

                    <div class="agpr-contextMenu top right">
                        <agpr-button
                            [id]="id + '.viewSeriesSource'"
                            icon="fa-regular fa-duotone fa-eye"
                            (click)="goToSeriesSource(series, $event)"
                            tooltip="Reports.series.source.viewSource"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </div>
                </div>
                <div
                    class="agpr-seriesPickerField-seriesHeading"
                    *ngIf="field.multiSeries"
                >
                    <span
                        class="agpr-seriesPickerField-seriesHeadingLabel"
                        id="seriesPickerField_seriesHeadingLabel_multiSeries_{{index}}"
                    >
                        {{ 'Reports.series.source.labelWithNumber' | localize: { 'number': i + 1 } }}
                        <span *ngIf="field.required" class="agpr-seriesPickerField-seriesHeadingLabel-required" aria-hidden="true">*</span>
                        <span *ngIf="field.required" class="sr-only"> {{ 'required' | localize }} </span>
                    </span>
                    <div class="agpr-contextMenu top right">
                        <agpr-button
                            class="agpr-seriesPickerField-seriesActionsButton"
                            [id]="id + '.viewSeriesSource'"
                            icon="fa-regular fa-duotone fa-eye"
                            (click)="goToSeriesSource(series, $event)"
                            tooltip="Reports.series.source.viewSource"
                            tooltipPosition="top"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                        <agpr-button
                            [disabled]="i == 0"
                            class="agpr-seriesPickerField-seriesActionsButton"
                            [id]="id + '.moveSeriesUp'"
                            [ngClass]="{
                                'agpr-seriesPickerFieldMoveUp': i !== seriesList.length - 1
                            }"
                            icon="fa-regular fa-arrow-up"
                            (click)="moveSeriesUp(i)"
                            tooltip="Reports.series.source.moveUp"
                            tooltipPosition="top"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                        <agpr-button
                            [disabled]="i == seriesList.length - 1"
                            class="agpr-seriesPickerField-seriesActionsButton"
                            [ngClass]="{
                                'agpr-seriesPickerFieldMoveDown': i !== 0
                            }"
                            icon="fa-regular fa-arrow-down"
                            (click)="moveSeriesDown(i)"
                            [id]="id + '.moveSeriesDown'"
                            tooltip="Reports.series.source.moveDown"
                            tooltipPosition="top"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                        <agpr-button
                            class="agpr-seriesPickerField-seriesActionsButton"
                            [id]="id + '.removeSeries'"
                            icon="fa-regular fa-duotone fa-trash-can"
                            (click)="removeSeries(i)"
                            [disabled]="seriesList.length == 1 && i == 0"
                            tooltip="Reports.series.source.deleteSource"
                            tooltipPosition="top"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </div>
                </div>
                <agpr-series-picker-item
                    [id]="id + '_seriesPickerField_source_' + i"
                    [index]="i"
                    [field]="field"
                    [showColorSwatch]="showColorSwatch || field?.showColorSwatch"
                    [defaultColors]="defaultColors"
                    [isBarChart]="isBarChart"
                    [ariaInvalid]="invalidSeriesIndexes.includes(i)"
                    [ariaDescribedBy]="ariaDescribedBy"
                    [(ngModel)]="seriesList[i]"
                    (ngModelChange)="itemChanged()"
                    [showHiddenOption]="showHiddenOption"
                    (inputFocused)="onInputFocus()"
                    (inputBlurred)="onInputBlur()"
                ></agpr-series-picker-item>
            </li>
        </ul>
        <div
            *ngIf="field.multiSeries"
            class="agpr-seriesPickerFieldAddSourceBtn"
        >
            <agpr-button
                (click)="addSeries()"
                [style]="buttonTypes.tertiary"
                [id]="id + '.addSourceButton'"
                label="Reports.series.addSource"
                [disabled]="seriesList && seriesList.length >= field.maxNumberOfSeries"
            ></agpr-button>
        </div>
        <div
            *ngIf="field.description"
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>
    </ng-template>
</div>

